import { queryOptions } from "@tanstack/react-query";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import type { McpServer } from "../types";
import { mcpGatewaysKeys } from "./query-keys";

const fetchMCPGateway = async ({
  client,
  gatewayId,
}: {
  client: ApiClient;
  gatewayId: string;
}): Promise<McpServer> => {
  const { data } = await client.get<McpServer>(`/gateways/${gatewayId}`);
  return data;
};

export const mcpGatewayQueryOptions = ({
  binding = "project",
  scope,
  gatewayId,
}: {
  binding?: ScopedBinding;
  scope: OrgProjectScope;
  gatewayId: string;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions<McpServer>({
    queryKey: mcpGatewaysKeys.detail({ binding, scope, id: gatewayId }),
    queryFn: () => fetchMCPGateway({ client, gatewayId }),
  });
};
